import { requireSession } from '@pwa/components/auth/auth-guard';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard')({
	beforeLoad: async ({ context }) => {
		const session = await requireSession(context.queryClient);
		if (!session) {
			throw redirect({ to: '/login', replace: true });
		}
	},
	component: RouteComponent,
});

function RouteComponent() {
	return <Outlet />;
}
